const ACCOUNT_SETTINGS = 'mbs_enable_accountsettings';

// Wether to send analytics data via GTM or default to GA
export const GTM_COLLECT_ANALYTICS = 'mbs_gtm_collect_analytics';

// Wether to delegate injecting thirdparty scripts to GTM or to leave it to the app
export const GTM_INJECT_THIRDPARTY = 'mbs_gtm_inject_thirdparty';

// use this map to switch on a feature, before cleanup
const isEnabled = {
  [ACCOUNT_SETTINGS]: true,
  [GTM_COLLECT_ANALYTICS]: true,
  [GTM_INJECT_THIRDPARTY]: true,
};

export const isFeatureEnabled = (featureName) => {
  return Boolean(isEnabled[featureName]) || document.cookie.includes(`${featureName}=true`);
};

export const isAccountSettingsEnabled = () => {
  return isFeatureEnabled(ACCOUNT_SETTINGS);
};
